// Handles setting and updating product form select values from URL parameters
export function initProductUrlParameterHandling({ cartForm }) {
    if (!cartForm) return;
    const urlParams = new URLSearchParams(window.location.search);

    // Set select options based on URL parameters
    const selects = cartForm.querySelectorAll('select');
    selects.forEach(select => {
        if (select.hasAttribute('data-no-url-update')) {
            return;
        }
        const attrName = select.getAttribute('name');
        if (urlParams.has(attrName)) {
            const paramValue = urlParams.get(attrName);
            const optionExists = Array.from(select.options).some(option => option.value === paramValue);
            if (optionExists) {
                select.value = paramValue;
            }
        }
        // Add change listeners to update URL when select options change
        select.addEventListener('change', () => {
            const attrName = select.getAttribute('name');
            const attrValue = select.value;
            const params = new URLSearchParams(window.location.search);
            params.set(attrName, attrValue);
            updateUrl(params);
        });
    });
}

function updateUrl(params) {
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${params.toString()}`;
    history.replaceState(null, '', newUrl);
}
